import gameState from "slotworks/model/game-state";
import RequestPayload from "slotworks/model/gameplay/requests/request-payload";

export default class GambleInitRequestPayload extends RequestPayload {
    public gambleID: number = gameState.getCurrentGame().getCurrentRecord().gambleID;
}
